
const io_port = {
    border: '1px solid #232323',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#000000',
    fontWeight: 'bold',
}


export const styles = {
    io_port: io_port,
}